import PropTypes from 'prop-types';
import React from 'react';
import { ButtonSelect } from '@upsales/components';
import CriteriaRowWrapper from '../CriteriaRowWrapper';
import T from 'Components/Helpers/translate';

import './BooleanInput.scss';

export default class BooleanInput extends React.Component {
	getOptionKey(option) {
		return `${option.value}::${option.comparisonType || 'Equals'}`;
	}

	onChange(option) {
		const { onChange, filter } = this.props;
		const newFilter = _.cloneDeep(filter);
		newFilter.comparisonType = option.comparisonType || 'Equals';

		onChange(option.value, newFilter);
	}

	render() {
		const { config, filter } = this.props;
		const options = _.filter(config.options, option => !option.inactive);
		const selectedKey = this.getOptionKey({ value: filter.value, comparisonType: filter.comparisonType });

		return (
			<CriteriaRowWrapper rowFlex>
				<div className="criteria-row">
					<ButtonSelect
						value={selectedKey}
						options={options.map(option => ({ title: T(option.text), value: this.getOptionKey(option) }))}
						onChange={key => this.onChange(options.find(option => this.getOptionKey(option) === key))}
					/>
				</div>
			</CriteriaRowWrapper>
		);
	}
}

BooleanInput.propTypes = {
	filter: PropTypes.object.isRequired,
	config: PropTypes.shape({ options: PropTypes.array.isRequired }).isRequired,
	onChange: PropTypes.func.isRequired
};
